import { I14V3VREGUL_State } from '@batical/types/src'

const I14V3VREGUL: I14V3VREGUL_State = {
  bati_version: 1,
  name: '',
  deleted: 0,
  saveDate: 0,
  in_kvVanne: 0.0,
  in_debitCircuit: 0.0,
  in_pdcReseau: 0.0,
  perteCharg_uuid: '6D91E213-CFEA-4A37-A3FF-5A3D10E60966',
  res_pdcVanne: 0.0,
  res_autoriteA: 0.0,
  mode: 'none',
  calcul_code: 'I14V3VREGUL'
}

export default I14V3VREGUL
